import React from 'react';
import { URLState } from '../../../types/zitoneoServicesTypes';
import Card from '../../../../../muiComponents/Card';
import useTranslate from '../../../../../customHooks/useTranslate';
import Icon from '../../../../../muiComponents/Icon';
import Button from '../../../../../muiComponents/Button';
import { useZitoneoSettings } from '../../../contexts/ZitoneoContentContext';
import Tag from '../../../../../muiComponents/Tag';
import IconButton from '../../../../../muiComponents/IconButton';
import Tooltip from '../../../../../muiComponents/Tooltip';

interface URLItemProps {
    url: URLState;
}

const URLItem = (props: URLItemProps) => {
    const { url } = props;
    const translate = useTranslate();
    const { editUrl } = useZitoneoSettings();

    return (
        <Card key={url.Id} className='settings__urls-list__item'>
            <div className='settings__urls-item__header'>
                <Icon
                    className={
                        url.IsPrimary
                            ? 'settings__urls-item__icon--primary'
                            : 'settings__urls-item__icon--not-primary'
                    }
                    iconName={url.IsPrimary ? 'StarBorder' : 'Link'}
                />
                <div className='flex flex-align-center gap-5'>
                    <p className='settings__urls-item__separator'>/</p>
                    <p>{url.Path}</p>
                </div>
            </div>
            <div className='settings__urls-item__actions'>
                {url.IsPrimary ? (
                    <p className='font-weight-b'>{translate('primary')}</p>
                ) : (
                    <Button
                        size='small'
                        variant='outlined'
                        onClick={() => editUrl(url.Id, 'IsPrimary', true)}
                    >
                        {translate('make_primary')}
                    </Button>
                )}
                <Tag
                    variant={url.Enabled ? 'contrast' : 'contained'}
                    color={url.Enabled ? 'green' : 'grey'}
                    text={
                        url.Enabled ? translate('live') : translate('disabled')
                    }
                />
                <div className='flex flex-align-center'>
                    <Tooltip titleText={url.Enabled ? 'disable' : 'enable'}>
                        <span>
                            <IconButton
                                iconName={
                                    url.Enabled ? 'Pause' : 'PlayArrowOutlined'
                                }
                                onClick={() =>
                                    editUrl(url.Id, 'Enabled', !url.Enabled)
                                }
                            />
                        </span>
                    </Tooltip>
                    <Tooltip titleText={'delete'}>
                        <span>
                            <IconButton
                                iconName='DeleteOutlined'
                                className='text-error-color'
                                onClick={() => editUrl(url.Id, 'Deleted', true)}
                            />
                        </span>
                    </Tooltip>
                </div>
            </div>
        </Card>
    );
};

export default URLItem;
